import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { AgrupacionnovedadesComponent } from './components/agrupacionnovedades/agrupacionnovedades.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { AgrupacionnovedadesRoutingModule } from './agrupacionnovedades-routing.module';
import { AgrupacionNovedadesService } from './services/agrupacion-novedades.service';
import { TipoNovedadService } from './services/tipo-novedad.service';

@NgModule({
  declarations: [
    AgrupacionnovedadesComponent,
    ConfirmDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatExpansionModule,
    MatCheckboxModule,
    AgrupacionnovedadesRoutingModule
  ],
  providers: [
    AgrupacionNovedadesService,
    TipoNovedadService
  ]
})
export class AgrupacionnovedadesModule { }
